import {
  DemanderKbn,
  DemanderRelationship,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

// 画面表示項目テーブルリスト
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411105_01,
  },
  {
    keyword: "retireeName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    title: "請求者区分",
    keyword: "demanderKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(DemanderKbn),
    requiredIcon: true,
  },
  {
    title: "続柄",
    keyword: "demanderRelationship",
    type: "radioWithText",
    radioPropsList: TkGetCodeList(DemanderRelationship).slice(1),
    inputProps: { maxLength: 20 },
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "退職者からの生計維持の有無（※1）",
    keyword: "livelihoodFromRetireeFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    showLine: false,
  },
  {
    title: "あなたと同順位の請求権保持者の有無（※2）",
    keyword: "demanderFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    showLine: false,
  },
  {
    keyword: "bereavedFamily",
    type: "explanatoryText",
    explanatoryText:
      labelids.labelid.LBLR411105_02 +
      "\\n" +
      labelids.labelid.LBLR411105_03 +
      "\\n" +
      labelids.labelid.LBLR411105_05,
    explanatoryTextRule: "\\n",
    showLine: false,
  },
  {
    keyword: "heir",
    type: "explanatoryText",
    explanatoryText:
      labelids.labelid.LBLR411105_02 +
      "\\n" +
      labelids.labelid.LBLR411105_04 +
      "\\n" +
      labelids.labelid.LBLR411105_06,
    explanatoryTextRule: "\\n",
    showLine: false,
  },
  {
    keyword: "spouseOnFamilyRegister",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411105_07,
    explanatoryTextRule: "\\n",
    showLine: false,
  },
  {
    keyword: "commonLawWifeOrHusband",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411105_08,
    explanatoryTextRule: "\\n",
    showLine: false,
  },
  {
    keyword: "livelihoodRelation",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411105_09,
    explanatoryTextRule: "\\n",
    showLine: false,
  },
  {
    keyword: "notLivelihoodRelation",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411105_10,
    explanatoryTextRule: "\\n",
    showLine: false,
  },
  {
    keyword: "heirRequiredDocuments",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR411105_11,
    explanatoryTextRule: "\\n",
    showLine: false,
  },
];

const schema1 = {
  demanderKbn: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const schema2 = {
  demanderRelationship: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export { steps, fakeTableList, schema1, schema2 };
